import inlineSVG from 'Vendor/inlineSvg';
import whenVisible from 'Utils/whenVisible.js';
import analytics from 'Scripts/analytics.js';


document.addEventListener('DOMContentLoaded', () => {
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	}, () => {
		document.documentElement.classList.toggle('is-loaded');
	});

	analytics.trackTaggedAnchors();

	// Apply class when element is visible
	whenVisible();

	/* Parallax scrolling effect */
	if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
		for (const event of ['load', 'scroll']) {
			window.addEventListener(event, () => {
				const parallaxElement = document.querySelectorAll('.parallax');
				const parallaxQuantity = parallaxElement.length;

				if (parallaxElement.length > 0) {
					window.requestAnimationFrame(() => {
						for (let i = 0; i < parallaxQuantity; i++) {
							const currentElement = parallaxElement[i];
							const windowTop = window.scrollY;
							const elementTop = currentElement.getBoundingClientRect().top + windowTop;
							const elementHeight = currentElement.offsetHeight;
							const viewPortHeight = (window.innerHeight * 0.5) - (elementHeight * 0.5);
							const scrolled = windowTop - elementTop + viewPortHeight;
							const amount = scrolled * (currentElement.dataset.depth * -1);

							currentElement.style.transform = `translate3d(0,${amount}px, 0)` + (currentElement.classList.contains('rotate') ? ` rotate(${amount * 0.08}deg)` : '');
						}
					});
				}
			});
		}
	}
});
